var exports = {
  "zr": "x93eb46d8--2c50c1--root",
  "i3": "x93eb46d8--2c50c1--root_desktop",
  "FR": "x93eb46d8--2c50c1--button-container",
  "Ug": "x93eb46d8--2c50c1--button-container_short",
  "sc": "x93eb46d8--2c50c1--narrow",
};

module.exports = exports;
